import type { FC } from 'react';
import { Link } from '@compat/router';
import { Picture } from '@ui';
import content from './components/content';
import { ruStore, huaStore, playStore, appleStoreNew } from '@images';
import FooterSocialIcons from './components/FooterSocialIcons';
import FooterRating from './components/FooterRating';
import { observer } from 'mobx-react';
import {
  APP_STORE,
  GOOGLE_PLAY,
  HUAWEI_STORE,
  RUSTORE
} from '@constants/appLinks';

interface MobileFooterProps {
  openCallbackModal: () => void;
}

const MobileFooter: FC<MobileFooterProps> = observer(
  ({ openCallbackModal }) => (
    <div className='mobile-footer'>
      <div className='question'>
        <div className='main-container'>
          <span>Есть вопросы?</span>
          <br /> Звоните
          <a href='tel:+74956409640'>
            <b> +7 495 640 9 640 </b>
          </a>{' '}
          с 06:00 до 00:00
        </div>
      </div>
      <div className='main-container'>
        <nav className='footer-menu'>
          <div className='menu-box menu-links'>
            <ul>
              <li className='header-menu'> О нас </li>
              {content.footerLinks.aboutUs?.map((item, index) => (
                <li key={index}>
                  <Link to={item.url}>{item.title}</Link>
                </li>
              ))}
            </ul>
            <ul>
              <li className='header-menu'> Покупателям </li>
              {content.footerLinks.forСlients?.map((item, index) => (
                <li key={index}>
                  <Link to={item.url}>{item.title}</Link>
                </li>
              ))}
            </ul>
          </div>
        </nav>
        <div className='menu-box'>
          <div className='header-menu'>Контакты</div>
          <div className='contacts'>
            <address>
              <span>140053, </span>
              <span>Котельники г, Московская обл.</span>
              ,
              <br />
              <span>Силикат мкр, строение № 4, Пом/Ком 2/6</span>
              <br />
            </address>
            <span className='name-organization'>
              <span>ООО «Д-Снаб»</span>
            </span>
            <div className='phone_number'>
              <a href='tel:+74956409640'>+7 495 640 9 640</a>
              <span className='work-time'>06:00 - 00:00</span>
            </div>
            <div className='feedback-box'>
              <span className='callback-link'>
                <span onClick={openCallbackModal}>Обратный звонок</span>
              </span>

              <span className='callback-link'>
                <Link
                  to={{
                    pathname: '/reviews'
                  }}
                >
                  {' '}
                  Обратная связь
                </Link>
              </span>
            </div>
          </div>
        </div>

        <div className='menu-box'>
          <ul className='payment'>
            {content.payments?.map((item, index) => (
              <li key={index}>
                <Picture
                  icon={item.img}
                  width={item.width}
                  height={item.height}
                  className={item.className}
                />
              </li>
            ))}
          </ul>
          <div className='footer-ratings-container'>
            <FooterRating type='yandex' />
            <FooterRating type='2gis' />
          </div>
        </div>

        <div className='social'>
          <div className='wrap'>
            <FooterSocialIcons isDarkGrey={false} />
            <div className='flex flex-col gap-3 pb-8'>
              <div className='mt-6'>
                Доставка по Москве и Московской области
              </div>
              <div className='flex flex-col gap-3'>
                <Link to='/license-agreement' className='underline'>
                  Пользовательское соглашение
                </Link>
                <Link to='/confidential' className='underline'>
                  Политика конфиденциальности
                </Link>
                <Link to='/pdn' className='underline'>
                  Согласие на обработку персональных данных
                </Link>
              </div>
            </div>
          </div>
          <ul className='flex footer-gap-4 md:order-1 sm:mb-6 sm:-order-1'>
            {[
              {
                id: 'appstore',
                title: 'App Store',
                href: APP_STORE,
                icon: appleStoreNew
              },
              {
                id: 'googlePlay',
                title: 'Google Play',
                href: GOOGLE_PLAY,
                icon: playStore
              },
              {
                id: 'huawei',
                title: 'Huawei',
                href: HUAWEI_STORE,
                icon: huaStore
              },
              {
                id: 'rustore',
                title: 'Rustore',
                href: RUSTORE,
                icon: ruStore
              }
            ].map(item => (
              <li key={item.id}>
                <a href={item.href} target='_blank' rel='noreferrer'>
                  <Picture
                    icon={item.icon}
                    pictureClassName='[&>img]:sm:w-9 [&>img]:sm:h-9'
                    width='40'
                    height='40'
                    alt={item.title}
                  />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className='copyright'>
        © {new Date().getFullYear()} Деликатеска.ру — интернет-магазин
        продуктов. Все права защищены
      </div>
    </div>
  )
);

export default MobileFooter;
